import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import Box from '../../../components/Box';
import BoxBody from '../../../components/Box/BoxBody';
import BoxHeader from '../../../components/Box/BoxHeader';
import Layout from '../../../components/Layout';
import DescriptionIcon from '@material-ui/icons/Description';
import TextField from "@material-ui/core/TextField";
import useReduxReducer from "../../../hooks/useReduxReducer";
import statsData from "./reducers";
import {useDispatch, useSelector} from "react-redux";
import {getStatsItemsAction} from "./actions";
import ItemsList from "../ClosureDetailPage/components/ItemsList";
import {LOADING} from "../../../enums/states";
import {endOfDay, format, startOfDay, subDays} from "date-fns";

const MainContentWrapper = styled.div`
  padding: 20px;
`;


const StatsPage = () => {
    useReduxReducer({ statsData });
    const dispatch = useDispatch();

    const today = new Date();
    const startOfYesterday = format(startOfDay(subDays(today, 1)), "yyyy-MM-dd'T'HH:mm");
    const endOfYesterday = format(endOfDay(subDays(today, 1)), "yyyy-MM-dd'T'HH:mm");

    const [from, setFrom] = useState(startOfYesterday);
    const [to, setTo] = useState(endOfYesterday);

    const [loading, setLoading] = useState(false);





    const refreshItemsData = (page, pageSize) => {
        dispatch(getStatsItemsAction(from, to , page, pageSize));
    };

    useEffect(async () => {
        await setLoading(true);
        await setLoading(false);
    }, [from, to])



    const items = useSelector((state) => state?.statsData?.items?.data);
    const itemsMeta = useSelector((state) => state?.statsData?.items?.metadata);

  return (
    <Layout>
      <MainContentWrapper>

        <GridRow>
          <ContentCard title={'Filtr'} icon={<DescriptionIcon />} color={'#88c8f5'}>
              <div style={{gap: '20px', display: 'flex', margin: '20px'}}>
              <TextField
                  id="from"
                  label="Od"
                  type="datetime-local"
                  InputLabelProps={{
                      shrink: true,
                  }}
                  defaultValue={from}
                  onChange={(e) => {
                      setFrom(e.target.value)
                  }}
              />

              <TextField
                  id="to"
                  label="Do"
                  type="datetime-local"
                  InputLabelProps={{
                      shrink: true,
                  }}
                  defaultValue={to}
                  onChange={(e) => {
                      console.log(e);
                      setTo(e.target.value)
                  }}
              />
              </div>
          </ContentCard>
        </GridRow>
        <GridRow>
          <ContentCard title={'Položky'} icon={<DescriptionIcon />} color={'#4af869'}>
              {!loading && <ItemsList data={items?.items || []} count={items?.count || 0} loading={itemsMeta?.fetchingData?.status === LOADING} refresh={refreshItemsData} />}
          </ContentCard>
        </GridRow>
      </MainContentWrapper>
    </Layout>
  );
};

export default StatsPage;

const Row = styled.div`
  margin-bottom: 60px;
`;

const GridRow = styled.div`
  gap: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  justify-content: center;
  //align-items: center;
`;

const ContentCard = ({ title, children, icon, color, actions }) => {
  return (
    <Row>
      <Box>
        <BoxHeader icon={icon} color={color} title={title} actions={actions} />
        <BoxBody style={{ paddingBottom: '30px' }}>{children}</BoxBody>
      </Box>
    </Row>
  );
};

